import { render, staticRenderFns } from "./TemplateSpares.vue?vue&type=template&id=0e4eba40&scoped=true"
import script from "./TemplateSpares.vue?vue&type=script&lang=js"
export * from "./TemplateSpares.vue?vue&type=script&lang=js"
import style0 from "./TemplateSpares.vue?vue&type=style&index=0&id=0e4eba40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4eba40",
  null
  
)

export default component.exports